const DEVICE_ID_STORAGE_KEY = 'bigsale.offline.device-id'

export function getOrCreateDeviceId(storage?: Storage): string {
  const deviceStorage = storage ?? localStorage
  const existing = deviceStorage.getItem(DEVICE_ID_STORAGE_KEY)

  if (existing !== null) {
    return existing
  }

  const deviceId = crypto.randomUUID()
  deviceStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId)

  return deviceId
}

export function buildOfflineContextKey(
  tenantCode: string,
  branchId: number,
  deviceId: string,
): string {
  return `${tenantCode}:${branchId}:${deviceId}`
}
